var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerpointIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-group2",
    transform: "translate(-92.000000, -496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-group3",
    transform: "translate(92.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "excel-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5405405,25.8498498 L28.5405405,7.01501502 C28.5405405,5.53513514 27.3297297,4.32432432 25.8498498,4.32432432 L7.01501502,4.32432432 C5.53513514,4.32432432 4.32432432,5.53513514 4.32432432,7.01501502 L4.32432432,25.8498498 C4.32432432,27.3297297 5.53513514,28.5405405 7.01501502,28.5405405 L25.8498498,28.5405405 C27.3297297,28.5405405 28.5405405,27.3297297 28.5405405,25.8498498 Z",
    id: "excel-icon-path1",
    fill: "#DD5B26",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8459581,13.2223054 C17.4980539,12.8848802 16.9070359,12.7172156 16.075,12.7172156 L14.6833832,12.7172156 L14.6833832,16.4781437 L16.064521,16.4781437 C16.9594311,16.4781437 17.5745509,16.2916168 17.9088323,15.9238024 C18.2137725,15.5905689 18.3636228,15.1399701 18.3636228,14.5709581 C18.3636228,14.0092814 18.1917665,13.5565868 17.8459581,13.2223054 Z M22.0480539,14.5332335 C22.0480539,15.775 21.7336826,16.8019461 21.1091317,17.6151198 C20.3001497,18.6682635 18.9535928,19.1953593 17.070509,19.1953593 L14.6823353,19.1953593 L14.6823353,24 L11,24 L11,10 L17.0076347,10 C18.7136228,10 20.0098802,10.4747006 20.8995509,11.4209581 C21.6655689,12.2320359 22.0480539,13.2694611 22.0480539,14.5332335 Z",
    id: "excel-icon-path2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpointIcon);
export default __webpack_public_path__ + "static/media/powerpoint-icon.14cf3675.svg";
export { ForwardRef as ReactComponent };